module.exports = __webpack_public_path__ + "img/控制器_control-2.242c3e11.svg";